import * as React from 'react'
import ContentLoader from 'react-content-loader'
import { Col, Row } from 'react-styled-flexboxgrid'
import Resizable from '../../../interfaces/Resizable'
import { ChapterContent, ContentOutline, TileCol, TileLoaderContainer, TileRow } from './style'

export const MDDimensionLoader: React.FC<Resizable> = ({ height, width = '100%' }) => (
  <ContentLoader
    height={42}
    width={500}
    speed={2}
    primaryColor="#f3f3f3"
    secondaryColor="#ecebeb"
    style={{ height, width }}
  />
)

const Loader: React.FC = () => {
  return (
    <Col>
      <ContentOutline>
        <Col md={4} className="no-padding">
          <Row>
            <Col md={5}>
              <MDDimensionLoader height="20px" />
            </Col>
          </Row>
        </Col>
        <Col md={8} />
      </ContentOutline>

      <ChapterContent>
        <TileRow id="scroller">
          {[1, 2].map(unit => (
            <TileCol id={`tile-${unit}`} onClick={() => {}} key={unit}>
              <TileLoaderContainer>
                <div className="tile-container">
                  <div className="content">
                    <div className="icon" />
                    <div className="text">
                      <MDDimensionLoader height="15px" />
                      <MDDimensionLoader height="15px" />
                    </div>
                  </div>
                  <div className="button">
                    <MDDimensionLoader height="15px" />
                  </div>
                </div>
              </TileLoaderContainer>
            </TileCol>
          ))}
        </TileRow>
      </ChapterContent>
    </Col>
  )
}

export default Loader
